import React from 'react';
import { SignInButton, SignUpButton, SignedIn, SignedOut } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import elsaiLogo from '../elsai.png';

const SignInPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex flex-col">
      {/* Navigation */}
      <nav className="flex justify-between items-center px-4 md:px-6 py-4 bg-white/80 backdrop-blur-sm border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <img src={elsaiLogo} alt="ARMS Logo" className="w-8 h-8 md:w-10 md:h-10" />
          <span className="text-xl md:text-2xl font-bold text-gray-800">ARMS</span>
        </div>
        <div className="flex items-center space-x-2 md:space-x-4">
          {/* Documentation link removed */}
        </div>
      </nav>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              Welcome to{' '}
              <span className="bg-gradient-to-r from-[#6c47ff] to-[#8b5cf6] bg-clip-text text-transparent">
                ARMS
              </span>
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Agent Resource Management System
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
            <div className="text-center">
              <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                Sign in to your account
              </h2>
              <p className="text-gray-600">
                Access your dashboard and manage your projects
              </p>
            </div>

            <div className="space-y-4">
              <SignedOut>
                <SignInButton mode="modal">
                  <button className="w-full bg-[#6c47ff] text-white rounded-lg font-medium px-6 py-3 hover:bg-[#5a3fd8] transition-colors shadow-md hover:shadow-lg">
                    Sign In
                  </button>
                </SignInButton>
                
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300" />
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-white text-gray-500">or</span>
                  </div>
                </div>

                <SignUpButton mode="modal">
                  <button className="w-full bg-white text-[#6c47ff] border border-[#6c47ff] rounded-lg font-medium px-6 py-3 hover:bg-[#6c47ff] hover:text-white transition-colors">
                    Create Account
                  </button>
                </SignUpButton>
              </SignedOut>

              <SignedIn>
                <button 
                  onClick={() => navigate('/dashboard')}
                  className="w-full bg-[#6c47ff] text-white rounded-lg font-medium px-6 py-3 hover:bg-[#5a3fd8] transition-colors shadow-md hover:shadow-lg"
                >
                  Go to Dashboard
                </button>
              </SignedIn>
            </div>

            <div className="text-center">
              <p className="text-sm text-gray-500">
                By signing in, you agree to our{' '}
                <button type="button" className="text-[#6c47ff] hover:underline bg-transparent border-0 p-0 cursor-pointer">
                  Terms of Service
                </button>{' '}
                and{' '}
                <button type="button" className="text-[#6c47ff] hover:underline bg-transparent border-0 p-0 cursor-pointer">
                  Privacy Policy
                </button>
              </p>
            </div>
          </div>

          <div className="text-center">
            <p className="text-sm text-gray-500">
              Need help?{' '}
              <a 
                href="mailto:elsai.support@optisolbusiness.com" 
                className="text-[#6c47ff] hover:underline"
              >
                Contact Support
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-6">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
          <div className="flex items-center justify-center space-x-3 mb-3">
            <img src={elsaiLogo} alt="ARMS Logo" className="w-6 h-6" />
            <span className="text-lg font-bold">ARMS Dashboard</span>
          </div>
          <p className="text-gray-400 text-sm">
            © 2025 elsai foundry. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SignInPage;
